/**
 * FAQ Manrina — contenu du prototype v7.4, porte tel quel.
 *
 * C'est la SOURCE DE VERITE de deux choses a la fois :
 * - les pages « Aide & contact » (recherche, questions frequentes) ;
 * - les reponses de RINA sur les regles et les chiffres.
 *
 * PRINCIPE (v7.4, decision Enzo) : sur une commission, une certification ou une
 * commande, **une reponse approximative vaut moins que rien**. RINA ne repond
 * donc jamais de tete : soit la FAQ contient la reponse, soit les donnees vives
 * du backend l'ont, soit elle le DIT et passe la main a l'equipe. Meme exigence
 * que le badge chlordecone : preuve, pas declaration.
 *
 * `cta` d'un item pointe vers un ecran du portail :
 *   { l: 'libelle', tab: 'wallet' }   -> onglet du hub
 *   { l: 'libelle', vue: 'securite' } -> sous-vue du Compte
 *   { l: 'libelle', module: 'marche' } -> module plein ecran
 */

import { MVP } from '../mvp'

export const FAQ = [
  {
    id: 'commander', ico: '🧺', titre: 'Commander & recevoir', pour: ['client'],
    items: [
      { id: 'c1', q: "Jusqu'à quand je peux commander ?", r: "Les commandes d'une tournée ferment le mardi à 20h, pour une livraison le vendredi. Passé cette heure, les producteurs récoltent et préparent : plus rien ne bouge." },
      { id: 'c2', q: 'Où et quand je récupère ma commande ?', r: "Trois façons : livraison à domicile partout sur l'île (5 €), point relais chez un commerce partenaire (2 €), ou retrait au marché du samedi (gratuit). Vous choisissez au moment de payer." },
      { id: 'c3', q: 'Je peux modifier ou annuler ma commande ?', r: "Oui, librement jusqu'à la clôture du mardi 20h. Après, la récolte est lancée — contactez-nous, on trouve toujours une solution.", cta: { l: 'Nous écrire', vue: 'aideContact' } },
      { id: 'c4', q: 'Un produit manque dans mon panier, que se passe-t-il ?', r: 'La nature décide parfois autrement. Le producteur propose un équivalent, ou le montant vous est recrédité en avoirs sur votre wallet — automatiquement, sans démarche de votre part.', cta: { l: 'Mon wallet', tab: 'wallet' } },
      { id: 'c5', q: 'Je peux acheter au marché sans commander avant ?', r: "Bien sûr. Le samedi, tout est ouvert à tout le monde, sans compte et sans réservation. L'appli sert juste à savoir qui sera là et avec quoi.", cta: { l: 'Les évènements', module: 'marche' } },
    ],
  },
  {
    id: 'paiement', ico: '💳', titre: 'Paiement & wallet', pour: ['client', 'producteur'],
    items: [
      { id: 'p1', q: 'Comment je paie ?', r: 'Par carte, en espèces au retrait, ou avec vos avoirs RINA. Vous pouvez combiner les trois : les avoirs se déduisent d’abord, le reste passe sur le moyen choisi.' },
      { id: 'p2', q: "C'est quoi mes avoirs RINA ?", r: "C'est votre cagnotte interne Manrina : remboursements, produits manquants, gestes commerciaux. Ils n'expirent jamais et sont utilisables sur n'importe quelle commande.", cta: { l: 'Mon wallet', tab: 'wallet' } },
      { id: 'p3', q: 'Mon argent part-il tout de suite au producteur ?', r: "Non. Il est mis de côté (séquestre) au moment de la commande, et le producteur n'est payé qu'après la livraison, une fois la fenêtre d'ajustement de 7 jours passée. Ça protège tout le monde." },
      { id: 'p4', q: 'Je peux récupérer mes avoirs en argent ?', r: 'Oui, sur simple demande. Écrivez-nous et on procède au virement.', cta: { l: 'Nous écrire', vue: 'aideContact' } },
    ],
  },
  {
    id: 'confiance', ico: '🌱', titre: 'Confiance & qualité',
    items: [
      { id: 'q1', q: 'Vos produits sont-ils garantis sans chlordécone ?', r: "C'est notre engagement le plus strict : preuve, jamais déclaration. Un producteur ne porte le badge que s'il a déposé une analyse validée et encore valide. Pas d'analyse à jour = pas de badge, sans exception." },
      { id: 'q2', q: "Comment je lis les badges d'un producteur ?", r: "Chaque badge correspond à un document vérifié par Manrina, avec une date d'expiration. Un badge grisé signifie que le certificat a expiré et attend un renouvellement.", cta: { l: 'Voir les évènements', module: 'marche' } },
      { id: 'q3', q: "D'où viennent les produits ?", r: 'Uniquement de producteurs matinitjè, nommés sur chaque ligne de votre commande. Aucun produit d’importation, aucun revendeur anonyme.' },
      { id: 'q4', q: 'Manrina prend une marge sur le prix producteur ?', r: 'Jamais. Le prix que le producteur fixe est sanctuarisé : il le touche intégralement. La commission Manrina est affichée séparément et facturée séparément.' },
    ],
  },
  {
    id: 'producteur', ico: '📦', titre: 'Côté producteur', pour: ['producteur'],
    items: [
      { id: 'r1', q: 'Combien Manrina prélève exactement ?', r: "10 % sur les Évènements, 30 % sur les Paniers (livraison, préparation et séquestre inclus). La TVA de 8,5 % s'applique uniquement sur la commission, jamais sur votre net. Votre prix ne bouge pas.", cta: { l: 'Ma facturation', tab: 'facturation' } },
      { id: 'r2', q: 'Quand suis-je payé ?', r: 'Pour les Paniers, à la clôture de la tournée : votre net est versé sur votre wallet producteur, une pièce de commission est émise en même temps. Pour un évènement, vous encaissez vous-même et réglez la commission après.', cta: { l: 'Mon wallet', tab: 'wallet' } },
      { id: 'r3', q: "Comment je m'inscris à un marché ?", r: 'Évènements → Événements → vous choisissez la date. Votre stand de référence est pré-rempli automatiquement : vous n’avez qu’à confirmer ou ajuster.', cta: { l: 'Les prochains évènements', module: 'marche' } },
      { id: 'r4', q: 'Je dois déclarer mon CA après un marché ?', r: "Oui, depuis Évènements → Historique. C'est cette déclaration qui déclenche votre facture de commission, que vous réglez ensuite par wallet, carte, virement ou espèces.", cta: { l: 'Ma facturation', tab: 'facturation' } },
      { id: 'r5', q: 'Un seul stock pour plusieurs canaux, ça marche comment ?', r: 'Vous saisissez votre stock une seule fois dans Mes offres, puis vous activez ou coupez chaque canal (Évènements, Paniers, Atelier). Le stock est partagé : ce qui part d’un côté baisse de l’autre.', cta: { l: 'Mes offres', tab: 'offers' } },
      { id: 'r6', q: 'Mes certifications expirent, que se passe-t-il ?', r: 'Vous êtes prévenu avant l’échéance. Passée la date, le badge disparaît de votre fiche publique jusqu’au dépôt du nouveau document — la promesse faite au client doit rester vraie.', cta: { l: 'Mon profil producteur', tab: 'profilprod' } },
      { id: 'r8', q: 'Pourquoi Manrina me demande mon Kbis et mon assurance ?', r: "Vu l'affluence, la mairie traite le marché comme un lieu recevant du public : chaque exposant doit être identifiable et assuré. Vos pièces ne sont jamais publiques — l'équipe Manrina les vérifie et ne les transmet qu'à la mairie ou au gestionnaire du lieu, pour l'autorisation du marché.", cta: { l: 'Mon dossier exposant', vue: 'dossier' } },
      { id: 'r7', q: 'Je ne peux pas venir au marché où je suis inscrit ?', r: 'Prévenez-nous le plus tôt possible sur WhatsApp : on libère votre emplacement et on informe les clients qui vous attendaient. Aucune pénalité.', cta: { l: 'Nous écrire', vue: 'aideContact' } },
    ],
  },
  {
    id: 'compte', ico: '👤', titre: 'Mon compte',
    items: [
      { id: 'm1', q: "J'ai oublié mon code PIN", r: "Si votre email est renseigné, vous recevez un lien de réinitialisation en quelques secondes. Sinon, il faut passer par nous — d'où l'intérêt d'ajouter votre email dès maintenant.", cta: { l: 'Sécurité & connexion', vue: 'securite' } },
      { id: 'm2', q: 'Comment je change de casquette ?', r: 'Touchez la pastille en haut à droite. Un seul compte porte toutes vos casquettes : client, producteur. Rien à recréer.' },
      { id: 'm3', q: 'Qui possède mes données ?', r: 'Vous. Vos données de production, de vente et de commande vous appartiennent : vous pouvez les exporter à tout moment, et les emporter si vous partez. Manrina ne les revend à personne.' },
      { id: 'm4', q: 'Comment je supprime mon compte ?', r: 'Écrivez-nous : la suppression est effective sous 30 jours, avec un export de vos données avant effacement si vous le souhaitez.', cta: { l: 'Nous écrire', vue: 'aideContact' } },
    ],
  },
]

// MVP (S62) : on ne repond pas sur une fonctionnalite masquee — une regle sur
// les paniers ou le wallet, sans l'ecran derriere, ne ferait que perdre la
// personne. Categories, questions et boutons suivent les drapeaux `mvp.js`.
const CATEGORIES_MASQUEES = new Set([
  ...(MVP.PANIERS ? [] : ['commander']),
  ...(MVP.WALLET || MVP.PANIERS ? [] : ['paiement']),
])
const QUESTIONS_MASQUEES = new Set([
  ...(MVP.PANIERS ? [] : ['r2']),                 // « Quand suis-je paye ? » (tournees, wallet)
  ...(MVP.PRODUCTEUR_HISTORIQUE ? [] : ['r4']),   // « Declarer mon CA » (onglet Historique)
  ...(MVP.DOSSIER_EXPOSANT ? [] : ['r8']),        // « Kbis et assurance » (dossier exposant, S73)
])
const ctaVisible = (cta) =>
  !cta
  || (cta.tab === 'wallet' ? MVP.WALLET
    : cta.tab === 'parametres' ? MVP.PARAMETRES
      : cta.tab === 'notifications' ? MVP.NOTIFICATIONS
        : cta.module === 'paniers' ? MVP.PANIERS
          : true)

/** Categories visibles pour une casquette (une categorie sans `pour` est universelle). */
export function faqPourCasquette(hubMode) {
  const role = hubMode === 'producer' ? 'producteur' : 'client'
  return FAQ
    .filter((c) => (!c.pour || c.pour.includes(role)) && !CATEGORIES_MASQUEES.has(c.id))
    .map((c) => ({
      ...c,
      items: c.items
        .filter((it) => !QUESTIONS_MASQUEES.has(it.id))
        .map((it) => (ctaVisible(it.cta) ? it : { ...it, cta: undefined })),
    }))
    .filter((c) => c.items.length > 0)
}

/** Recherche plein texte pour la page Aide (tous les mots comptent). */
export function faqRecherche(q, cats) {
  const n = normaliser(q)
  if (!n.trim()) return []
  return cats.flatMap((c) => c.items
    .filter((it) => normaliser(it.q).includes(n) || normaliser(it.r).includes(n))
    .map((it) => ({ ...it, cat: c })))
}

// ── Moteur de reponse de RINA ────────────────────────────────────────────────

const MOTS_VIDES = new Set(['je', 'j', 'le', 'la', 'les', 'de', 'des', 'du', 'un', 'une', 'est', 'ce', 'que', 'qui', 'quoi', 'comment', 'pourquoi', 'pour', 'mon', 'ma', 'mes', 'a', 'au', 'aux', 'et', 'en', 'sur', 'dans', 'tu', 'vous', 'on', 'il', 'elle', 'quand', 'ou', 'se', 'sont', 'avec', 'pas', 'plus', 'fait', 'faire', 'peux', 'peut', 'dois', 'doit', 'y', 'l', 'd', 's', 'n', 'me', 'moi', 'si', 'sa', 'son', 'ses'])

export const normaliser = (s) => String(s || '').toLowerCase()
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-z0-9\s]/g, ' ')

const motsUtiles = (s) => normaliser(s).split(/\s+/).filter((m) => m.length > 2 && !MOTS_VIDES.has(m))

/**
 * Meilleure entree FAQ pour une question.
 *
 * Score : chaque mot retrouve dans l'INTITULE compte ×3, dans la reponse ×1.
 * Seuil a 3 — bas, mais non nul : mieux vaut « je ne sais pas » qu'une reponse
 * a cote. Renvoie `null` quand rien ne depasse le seuil.
 */
export function rinaCherche(q, cats) {
  const mots = motsUtiles(q)
  if (!mots.length) return null
  let meilleur = null
  cats.forEach((c) => c.items.forEach((it) => {
    const nq = normaliser(it.q)
    const nr = normaliser(it.r)
    let score = 0
    mots.forEach((m) => { if (nq.includes(m)) score += 3; else if (nr.includes(m)) score += 1 })
    if (score > 0 && (!meilleur || score > meilleur.score)) meilleur = { it, cat: c, score }
  }))
  return meilleur && meilleur.score >= 3 ? meilleur : null
}

/** Politesses reconnues hors ligne — RINA reste matinitje dans le ton. */
export const RINA_SALUTS = [
  { mots: ['bonjou', 'bonjour', 'bonsoir', 'salut', 'sa ka fet', 'coucou', 'hello'], r: 'Bonjou ! Content de vous lire. Posez-moi votre question — ou touchez une des propositions ci-dessous.' },
  { mots: ['merci', 'mesi', 'nickel', 'parfait', 'super'], r: 'Avec plaisir. Je reste là si autre chose vous vient.' },
  { mots: ['qui es tu', 'qui est tu', 'tu es qui', 'c est quoi rina', 'ton nom'], r: "Je suis RINA, le guide de Manrina. Je réponds à vos questions et je vous emmène au bon endroit dans l'appli. Je ne passe pas de commande et je ne touche pas à vos stocks — ça, ça reste entre vos mains." },
]

/** Suggestions de depart selon le LIEU d'ouverture et la casquette. */
const SUGG_CTX = {
  'marche:client': ['c5', 'q2', 'q1'], 'marche:producteur': ['r3', 'r4', 'r1'],
  'paniers:client': ['c1', 'c4', 'p3'], 'paniers:producteur': ['r2', 'r5', 'r1'],
  'wallet:client': ['p2', 'p3', 'p4'], 'wallet:producteur': ['r2', 'p2', 'r1'],
  'facturation:producteur': ['r1', 'r4', 'r2'], 'profilprod:producteur': ['r6', 'q1', 'r3'],
  'offers:producteur': ['r5', 'r1', 'r2'],
}

export function rinaSuggestions(lieu, hubMode) {
  const role = hubMode === 'producer' ? 'producteur' : 'client'
  const cats = faqPourCasquette(hubMode)
  const ids = (lieu && SUGG_CTX[`${lieu}:${role}`]) || (role === 'producteur' ? ['r1', 'r2', 'r6'] : ['c1', 'p2', 'q1'])
  const tous = cats.flatMap((c) => c.items)
  const sel = ids.map((id) => tous.find((it) => it.id === id)).filter(Boolean)
  return sel.length ? sel : tous.slice(0, 3)
}
